import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MaterialModule } from 'src/shared/material/material.module';
import { CommonModule } from '@angular/common';
import { PurchaseOrderDetailsComponent } from './purchase-order-details.component';
import { CurrencyInputModule } from 'src/shared/currency-input/currency-input.module';
import { MultiChipInputModule } from 'src/shared/multi-chip-input/multi-chip-input.module';
import { CommonUiModule } from 'src/shared/common-ui/common-ui.module';

@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		MaterialModule,
		FlexLayoutModule,
		CurrencyInputModule,
		MultiChipInputModule,
		CommonUiModule,
	],
	declarations: [PurchaseOrderDetailsComponent],
	exports: [PurchaseOrderDetailsComponent],
})
export class PurchaseOrderDetailsModule {}
